<template>
  <div class="chat-panel">
    <h3 class="chat-title">채팅</h3>

    <div class="chat-messages" ref="messagesContainer">
      <div
        v-for="(msg, index) in messages"
        :key="index"
        :class="['chat-message', msg.isMine ? 'mine' : 'other']"
      >
        <span class="chat-session">{{ msg.sessionId || '알 수 없음' }}</span>
        <span class="chat-content">{{ msg.content }}</span>
      </div>
      <div v-if="messages.length === 0" class="chat-empty">
        메시지가 없습니다
      </div>
    </div>

    <div class="chat-input-area">
      <input
        v-model="message"
        placeholder="메시지를 입력하세요"
        class="chat-input"
        @keyup.enter="handleSend"
      />
      <button @click="handleSend" class="chat-send-button">전송</button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, nextTick, onBeforeUnmount } from 'vue';
import Cookies from 'js-cookie';
import { subscribeChatRoom, unsubscribeChatRoom, sendChatMessage } from '@/utils/socketService';

const props = defineProps({
  stompClient: { type: Object, default: null },
  roomName: { type: String, default: '' },
});

const message = ref('');
const messages = ref([]);
const messagesContainer = ref(null);

let subscribedRoom = null;

const scrollToBottom = async () => {
  await nextTick();
  if (messagesContainer.value) {
    messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight;
  }
};

const subscribe = () => {
  if (!props.stompClient?.connected || !props.roomName) return;

  subscribeChatRoom(props.stompClient, props.roomName, (data) => {
    const senderSession = data.sessionId || '';
    const mySessionId = Cookies.get('sessionId') || '';
    const isMine = senderSession !== '' && senderSession === mySessionId;

    messages.value.push({
      content: data.content,
      sessionId: senderSession,
      isMine,
    });
    scrollToBottom();
  });

  subscribedRoom = props.roomName;
};

const unsubscribe = () => {
  if (subscribedRoom && props.stompClient) {
    unsubscribeChatRoom(props.stompClient, subscribedRoom);
    subscribedRoom = null;
  }
};

const handleSend = () => {
  if (!message.value.trim() || !props.stompClient?.connected || !props.roomName) return;
  sendChatMessage(props.stompClient, props.roomName, message.value);
  message.value = '';
};

// stompClient / roomName이 세팅되면 자동 구독
watch(
  () => [props.stompClient, props.roomName],
  ([client, room], oldVal) => {
    const prevClient = oldVal?.[0];
    const prevRoom = oldVal?.[1];
    if (prevRoom && prevClient) {
      unsubscribe();
    }
    if (client?.connected && room) {
      messages.value = [];
      subscribe();
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  unsubscribe();
});
</script>
